import SlickSlider from '../SlickSlider';

/**
 * Component: SecureOverview
 */

export default class SecureOverview {
    constructor() {
        this.selectors = {
            root: '[data-secure-overview]',
            activeList: '[data-secure-overview-active]',
            slider: '[data-secure-overview-slider]',
            textSlider: '[data-secure-overview-text-slider]',
            numberSlider: '[data-secure-overview-number-slider]',
            numberSliderButton: '[data-number-slider-button]',
            activeButtonByIndex: (index) => '[data-secure-overview-active-index="' + index + '"]',
            sliderButtonByIndex: (index) => '[data-secure-overview-number-slide-index="' + index + '"]'
        };

         // classes
        this.classes = {
            active: 'active'
        };

        this.$rootElement = $(this.selectors.root);
        this.$numberSlider = this.$rootElement.find(this.selectors.numberSlider);
        this.$textSlider = this.$rootElement.find(this.selectors.textSlider);
        this.$numberSliderButton = this.$rootElement.find(this.selectors.numberSliderButton);
        this.$activeList = this.$rootElement.find(
            this.selectors.activeList
        );
        this.$slider = this.$rootElement.find(this.selectors.slider);
        this.init();
    }

    init() {
        this.createTextSlider();
        this.createSlider();
        this.bindEvents();
        this.updateActive(0);
        this.updateNumberSlider(0);
    }

    updateNumberSlider(index) {
        const $allButtons = this.$numberSlider.find('button');
        const $targetButton = this.$rootElement.find(
            this.selectors.sliderButtonByIndex(index)
        );

        $allButtons.removeClass(this.classes.active);
        $targetButton.addClass(this.classes.active);
    }

    updateActive(index) {
        var $allButtons = this.$activeList.find('button');
        var $targetButton = this.$rootElement.find(
            this.selectors.activeButtonByIndex(index)
        );
        $allButtons.removeClass(this.classes.active);
        $targetButton.addClass(this.classes.active);
    }

    createTextSlider() {
        const config = {
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: false,
            asNavFor: this.$slider,
            slidesToScroll: 1,
            slidesToShow: 1,
            rows: 0,
            variableWidth: false
        };

        return new SlickSlider(this.$textSlider, config);
    }

    createSlider() {
        const config = {
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: true,
            fade: true,
            dots: false,
            variableWidth: false,
            slidesToScroll: 1,
            rows: 0
        };

        return new SlickSlider(this.$slider, config);
    }

    bindEvents() {
        // handle active list click
        this.$activeList.on('click', 'button', (event) => {
            var $targetButton = $(event.currentTarget);
            var index = $targetButton.data('secureOverviewActiveIndex');

            this.$slider.slick('slickGoTo', index);
            this.$textSlider.slick('slickGoTo', index);
        });

        // handle number slider click
        this.$numberSliderButton.on('click', 'button', (event) => {
            var $targetButton = $(event.currentTarget);
            var index = $targetButton.data('secureOverviewNumberSlideIndex');

            this.$textSlider.slick('slickGoTo', index);
            this.$slider.slick('slickGoTo', index);
        });

        // handle slider initialization
        this.$slider.on('init', (event, slick) => {
            var activeSlide = slick.$slider.find('.slick-active');
            var index = activeSlide.data('slickIndex');

            this.updateActive(index);
            this.updateNumberSlider(index);
        });

        // handle slide change
        this.$slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            this.updateActive(nextSlide);
            this.updateNumberSlider(nextSlide);
        });
    }
}
